import { useSelector } from "react-redux";
import RivalsButton from "rivals/components/shared/Button";
import { getUpcomingBilling } from "rivals/redux/subscriptionAddons/selectors";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import strings from "./strings";
import { PurchaseSuccessStepProps } from "./types";
import AddOnSuccess from "../../../AddOnSuccess";

const { billingSummary, successTitle } = strings;

const PurchaseSuccessStep = ({
  parentPhilter,
  addOn,
  closeButtonClick
}: PurchaseSuccessStepProps): JSX.Element => {
  const upcomingBilling = useSelector(getUpcomingBilling);

  return (
    <div
      className={styles.modalBody}
      {...setData(parentPhilter, "receipt-step")}
    >
      <div
        className={styles.addOnTitle}
        {...setData(parentPhilter, "receipt-title")}
      >
        {successTitle(addOn.name)}
      </div>
      <div className={styles.textPrompt}>{billingSummary}</div>
      <div
        className={styles.billingContainer}
        {...setData(parentPhilter, "receipt")}
      ></div>
      <AddOnSuccess addOn={addOn} upcomingBilling={upcomingBilling} />
      <RivalsButton
        buttonText="OK"
        fullWidth
        onClick={(): void => closeButtonClick(true)}
        {...setData(parentPhilter, "receipt-close-modal")}
      />
    </div>
  );
};

export default PurchaseSuccessStep;
